import { defineComponent as _defineComponent } from 'vue'
import TvtimeImporter from '@/features/tvtime-importer/TvtimeImporter.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'TvtimeImporterPage',
  setup(__props) {


return { __sfc: true,TvtimeImporter }
}

})